var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"book-header-loader",class:{'visible': _vm.$store.getters['headerLoader/visible']}},[_c('book-loader',{attrs:{"small":true}}),_vm._v(" "),_c('div',{staticClass:"book-header-loader-text"},[_vm._v("processing")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }